import React, { useEffect } from "react";
import { useThree } from "@react-three/fiber";

const PauseScene = ({ hide3D }) => {
  const { scene } = useThree(); // Récupère la scène

  useEffect(() => {
    if (!scene) return; // Si la scène n'est pas définie, on sort de l'effet

    // Applique le changement de matériau ou effet sur les objets de la scène
    scene.traverse((object) => {
      if (object.isMesh) {
        // Applique les effets ou changements sur chaque objet de type "Mesh"
        if (hide3D) {
          // Exemple de modification de matériau, ici on désactive l'effet
          object.material.opacity = 0.5;
          object.material.transparent = true;
        } else {
          // Restaure les paramètres de base lorsque la scène n'est pas en pause
          object.material.opacity = 1;
          object.material.transparent = false;
        }
      }
    });
  }, [hide3D, scene]); // Ré-exécute cet effet si `isPaused` ou `scene` change

  return null; // Ce composant ne rend rien directement
};

export default PauseScene;
